export const selectJourneyState = state => state.journey;
